import SidebarsIsOpenService from "@core-ui/ContextServices/Sidebars/SidebarsIsOpenContext";
import SidebarsIsPinService from "@core-ui/ContextServices/Sidebars/SidebarsIsPin";
import ArticleViewService from "@core-ui/ContextServices/views/articleView/ArticleViewService";
import { cssMedia } from "@core-ui/utils/cssUtils";
import { useMediaQuery } from "@react-hook/media-query";
import { useRef } from "react";
import ArticleLayout from "./ArticleLayout";

export interface ArticleComponentProps {
	article: JSX.Element;
	rightNav: JSX.Element;
}

const ArticleComponent = (props: ArticleComponentProps) => {
	const { article, rightNav } = props;
	const isSidebarLeftPin = SidebarsIsPinService.value.left;
	const isSidebarRightPin = SidebarsIsPinService.value.right;
	const isSidebarRightOpen = SidebarsIsOpenService.value.right;
	const useArticleDefaultStyles = ArticleViewService.useArticleDefaultStyles;
	const additionalStyles = ArticleViewService.additionalStyles;

	const isRightNavHover = useRef(false);

	const onArticleMouseEnterHandler = () => {
		if (!isSidebarLeftPin) {
			SidebarsIsOpenService.value = { left: false };
		}
		if (!isSidebarRightPin) {
			SidebarsIsOpenService.value = { right: false };
		}
	};

	const onRightNavTransitionEndHandler = () => {
		SidebarsIsOpenService.transitionEndIsRightOpen = isRightNavHover.current;
	};

	return (
		<ArticleLayout
			additionalStyles={additionalStyles}
			article={article}
			isRightNavOpen={isSidebarRightOpen}
			isRightNavPin={isSidebarRightPin}
			narrowMedia={useMediaQuery(cssMedia.JSmedium)}
			onArticleMouseEnter={onArticleMouseEnterHandler}
			onRightNavTransitionEnd={onRightNavTransitionEndHandler}
			rightNav={rightNav}
			useArticleDefaultStyles={useArticleDefaultStyles}
		/>
	);
};

export default ArticleComponent;
